module.exports = __webpack_public_path__ + "img/rivers-end-pub-11.2.24.34fdac2e.png";